import { ViewResolver } from '@Components/ViewResolver';
import DetailsTabDesktop from './desktop/DetailsTabDesktop';
import DetailsTabMobile from './mobile/DetailsTabMobile';

const DetailsTab: React.FC = () => {
  return (
    <ViewResolver
      desktop={<DetailsTabDesktop />}
      mobile={<DetailsTabMobile />}
    />
  );
};

export default DetailsTab;
